import React from 'react';
import { Container } from '../components/Container';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Twitter, ShieldCheck } from 'lucide-react';
export function Contact() {
  return <div className="w-full bg-white" data-id="element-380">
      {/* Header */}
      <div className="bg-[#111827] text-white py-16" data-id="element-381">
        <Container data-id="element-382">
          <div className="max-w-3xl" data-id="element-383">
            <h1 className="font-oswald text-4xl md:text-5xl font-bold uppercase mb-4" data-id="element-384">
              Contact Us
            </h1>
            <div className="w-20 h-1.5 bg-pts-red mb-6" data-id="element-385"></div>
            <p className="text-xl text-gray-300" data-id="element-386">
              Have a question, need a quote, or ready to start an order? Our
              team is here to help.
            </p>
          </div>
        </Container>
      </div>

      {/* Quote Callout Band */}
      <div className="bg-pts-red text-white py-4" data-id="element-387">
        <Container data-id="element-388">
          <div className="flex flex-col sm:flex-row items-center justify-center text-center sm:text-left gap-4" data-id="element-389">
            <ShieldCheck className="h-6 w-6 flex-shrink-0" data-id="element-390" />
            <div data-id="element-391">
              <span className="font-oswald text-xl font-bold uppercase tracking-wide mr-2" data-id="element-392">
                Have a quote? Send it to us.
              </span>
              <span className="text-white/90 font-medium" data-id="element-393">
                Email your current quote to savemoney@getcustomuniforms.com and
                we'll help you compare.
              </span>
            </div>
          </div>
        </Container>
      </div>

      <Container className="py-20" data-id="element-394">
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-395">
          {/* Left Column: Form */}
          <div className="lg:w-2/3" data-id="element-396">
            <h2 className="font-oswald text-3xl font-bold uppercase text-gray-900 mb-6" data-id="element-397">
              Send a Message
            </h2>
            <form className="space-y-6 bg-gray-50 p-8 rounded-xl border border-gray-200" onSubmit={e => e.preventDefault()} data-id="element-398">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-399">
                <div data-id="element-400">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-401">
                    First Name *
                  </label>
                  <input type="text" required className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-402" />
                </div>
                <div data-id="element-403">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-404">
                    Last Name *
                  </label>
                  <input type="text" required className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-405" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-406">
                <div data-id="element-407">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-408">
                    Email Address *
                  </label>
                  <input type="email" required className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-409" />
                </div>
                <div data-id="element-410">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-411">
                    Phone Number
                  </label>
                  <input type="tel" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-412" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-413">
                <div data-id="element-414">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-415">
                    Organization / Team Name
                  </label>
                  <input type="text" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-416" />
                </div>
                <div data-id="element-417">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-418">
                    Inquiry Type *
                  </label>
                  <select required className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-419">
                    <option value="" data-id="element-420">Select an Option</option>
                    <option value="order" data-id="element-421">Start an Order</option>
                    <option value="mockups" data-id="element-422">Request Free Art Mockups</option>
                    <option value="quote" data-id="element-423">Submit a Quote for Comparison</option>
                    <option value="wholesale" data-id="element-424">
                      Wholesale / Large Organization
                    </option>
                    <option value="team-store" data-id="element-425">Team Store Setup</option>
                    <option value="other" data-id="element-426">Other / General Question</option>
                  </select>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-427">
                <div data-id="element-428">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-429">
                    Sport
                  </label>
                  <select className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-430">
                    <option data-id="element-431">Select a Sport</option>
                    <option data-id="element-432">Baseball</option>
                    <option data-id="element-433">Basketball</option>
                    <option data-id="element-434">Football</option>
                    <option data-id="element-435">Softball</option>
                    <option data-id="element-436">Soccer</option>
                    <option data-id="element-437">Cheer</option>
                    <option data-id="element-438">Volleyball</option>
                    <option data-id="element-439">Track & Field</option>
                    <option data-id="element-440">Other / Groupwear</option>
                  </select>
                </div>
                <div data-id="element-441">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-442">
                    Estimated Quantity
                  </label>
                  <select className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-443">
                    <option data-id="element-444">Select Quantity</option>
                    <option data-id="element-445">10 - 50</option>
                    <option data-id="element-446">51 - 150</option>
                    <option data-id="element-447">151 - 500</option>
                    <option data-id="element-448">500+</option>
                  </select>
                </div>
              </div>

              <div data-id="element-449">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-450">
                  Message *
                </label>
                <textarea required rows={5} className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white resize-none" placeholder="How can we help you?" data-id="element-451"></textarea>
              </div>

              <div className="pt-2" data-id="element-452">
                <button type="submit" className="bg-pts-red hover:bg-pts-red-dark text-white px-8 py-3 rounded font-bold uppercase tracking-wide transition-colors" data-id="element-453">
                  Send Message
                </button>
                <p className="text-sm text-gray-500 mt-4" data-id="element-454">
                  Note: If you have a quote or artwork files to attach, please
                  email them directly to{' '}
                  <a href="mailto:savemoney@getcustomuniforms.com" className="text-pts-red hover:underline" data-id="element-455">
                    savemoney@getcustomuniforms.com
                  </a>
                  .
                </p>
              </div>
            </form>
          </div>

          {/* Right Column: Info */}
          <div className="lg:w-1/3" data-id="element-456">
            <div className="bg-[#111827] text-white rounded-xl p-8 shadow-lg sticky top-28" data-id="element-457">
              <h3 className="font-oswald text-2xl font-bold uppercase mb-6 border-b border-gray-700 pb-4" data-id="element-458">
                Contact Information
              </h3>

              <div className="space-y-6" data-id="element-459">
                <div className="flex items-start" data-id="element-460">
                  <Phone className="h-6 w-6 text-pts-red mr-4 flex-shrink-0" data-id="element-461" />
                  <div data-id="element-462">
                    <h4 className="font-bold text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-463">
                      Phone
                    </h4>
                    <a href="tel:8882188647" className="text-lg font-bold hover:text-pts-red transition-colors" data-id="element-464">
                      888.218.8647
                    </a>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-465">
                  <Mail className="h-6 w-6 text-pts-red mr-4 flex-shrink-0" data-id="element-466" />
                  <div data-id="element-467">
                    <h4 className="font-bold text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-468">
                      Sales & Quotes
                    </h4>
                    <a href="mailto:savemoney@getcustomuniforms.com" className="hover:text-pts-red transition-colors break-all" data-id="element-469">
                      savemoney@getcustomuniforms.com
                    </a>

                    <h4 className="font-bold text-sm text-gray-400 uppercase tracking-wider mt-3 mb-1" data-id="element-470">
                      Support
                    </h4>
                    <a href="mailto:support@getcustomuniforms.com" className="hover:text-pts-red transition-colors break-all" data-id="element-471">
                      support@getcustomuniforms.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-472">
                  <MapPin className="h-6 w-6 text-pts-red mr-4 flex-shrink-0" data-id="element-473" />
                  <div data-id="element-474">
                    <h4 className="font-bold text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-475">
                      Address
                    </h4>
                    <p className="text-gray-300" data-id="element-476">
                      Primetime Sports Apparel
                      <br data-id="element-477" />
                      9229 Southampton Place
                      <br data-id="element-478" />
                      Boca Raton, Florida 33434
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-479">
                  <Clock className="h-6 w-6 text-pts-red mr-4 flex-shrink-0" data-id="element-480" />
                  <div data-id="element-481">
                    <h4 className="font-bold text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-482">
                      Hours
                    </h4>
                    <p className="text-gray-300" data-id="element-483">
                      Monday – Friday
                      <br data-id="element-484" />
                      9:00 AM – 7:00 PM EST
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-gray-700" data-id="element-485">
                <h4 className="font-bold text-sm text-gray-400 uppercase tracking-wider mb-4" data-id="element-486">
                  Follow Us
                </h4>
                <div className="flex space-x-4" data-id="element-487">
                  <a href="#" className="bg-gray-800 p-2.5 rounded hover:bg-pts-red transition-colors" data-id="element-488">
                    <Facebook className="h-5 w-5" data-id="element-489" />
                  </a>
                  <a href="#" className="bg-gray-800 p-2.5 rounded hover:bg-pts-red transition-colors" data-id="element-490">
                    <Instagram className="h-5 w-5" data-id="element-491" />
                  </a>
                  <a href="#" className="bg-gray-800 p-2.5 rounded hover:bg-pts-red transition-colors" data-id="element-492">
                    <Twitter className="h-5 w-5" data-id="element-493" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>;
}